export async function encrypt(text, password) {
    const enc = new TextEncoder();
    const keyMaterial = await crypto.subtle.importKey(
        "raw",
        enc.encode(password),
        { name: "PBKDF2" },
        false,
        ["deriveKey"]
    );

    const key = await crypto.subtle.deriveKey(
        {
            name: "PBKDF2",
            salt: enc.encode("salt"),
            iterations: 100000,
            hash: "SHA-256"
        },
        keyMaterial,
        { name: "AES-GCM", length: 256 },
        false,
        ["encrypt"]
    );

    const iv = crypto.getRandomValues(new Uint8Array(12));
    const encodedText = enc.encode(text);
    const encryptedContent = await crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: iv
        },
        key,
        encodedText
    );

    const combinedArray = new Uint8Array(
        iv.length + encryptedContent.byteLength
    );
    combinedArray.set(iv);
    combinedArray.set(new Uint8Array(encryptedContent), iv.length);

    return btoa(String.fromCharCode(...combinedArray));
}

export async function decrypt(encryptedText, password) {
    const combinedArray = new Uint8Array(
        atob(encryptedText)
            .split("")
            .map(char => char.charCodeAt(0))
    );
    const iv = combinedArray.slice(0, 12);
    const encryptedContent = combinedArray.slice(12);

    const enc = new TextEncoder();
    const keyMaterial = await crypto.subtle.importKey(
        "raw",
        enc.encode(password),
        { name: "PBKDF2" },
        false,
        ["deriveKey"]
    );

    const key = await crypto.subtle.deriveKey(
        {
            name: "PBKDF2",
            salt: enc.encode("salt"),
            iterations: 100000,
            hash: "SHA-256"
        },
        keyMaterial,
        { name: "AES-GCM", length: 256 },
        false,
        ["decrypt"]
    );

    const decryptedContent = await crypto.subtle.decrypt(
        {
            name: "AES-GCM",
            iv: iv
        },
        key,
        encryptedContent
    );

    const dec = new TextDecoder();
    return dec.decode(decryptedContent);
}
